import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import AuditTableItem from "./TableItem";
import AuditTableItemMobile from "./TableItemMobile";
import downArrowIcon from "assets/images/down-arrow-icon.svg";
import SwapVertIcon from '@mui/icons-material/SwapVert';

import styles from "./MainApp.organisms.Product.Table.module.scss";
import i18n from "i18n";
import { isMobile } from "helpers/Mobile";

const AuditTable = ({ audits, headers, headerClickHandler }) => {
  const [selected, setSelected] = useState(null);

  const history = useHistory();

  const handleSelectOne = (selectedId) => {
    if (selected === selectedId) {
      setSelected(null);
    } else {
      setSelected(selectedId);
    }
  };

const handleClickAudit = (audit) => {
  if (!audit || !audit.id) {
    console.error('Invalid audit object:', audit);
    return;
  }
  history.push(`/admin/stock/view-audit-details/${audit.id}`, {
    auditData: {
      date: audit.date,
      path_name: audit.path_name,
      status: audit.status,
      business: audit.business
    }
  });
};

  const renderOrderIcon = (column) => {
    const direction = headers[column];

    if (!headers || typeof headers[column] === "undefined" || headers[column] === null) {
      return <SwapVertIcon style={{ fontSize: '14px', marginLeft: '5px', opacity: 0.5 }} />;
    }

    const raw = headers[column];
    let dir = null;
    if (typeof raw === "string") {
      dir = raw;
    } else if (typeof raw === "object" && raw !== null) {
      dir = raw.direction ?? raw.value ?? null;
    }

    const arrowStyle = {
      width: '9px',
      height: '9px',
      marginLeft: '5px',
    };

    if (direction === "ASC") {
      return <img src={downArrowIcon} style={{ ...arrowStyle, transform: "rotate(180deg)" }} alt="Up Arrow" />;
    }

    if (direction === "DESC") {
      return <img src={downArrowIcon} style={{ ...arrowStyle }} alt="Down Arrow" />;
    }
    return <SwapVertIcon style={{ fontSize: '14px', marginLeft: '5px', opacity: 0.5 }} />;
  };

  return (
    <div className={styles["table-container"]}>
      {/* Desktop */}
      {!isMobile && (
        <div className={styles["table-desktop"]} data-automation-id="audit-table">
          <div className={styles["table-header"]}>
            <div
              data-automation-id="sort-by-date"
              onClick={() => headerClickHandler && headerClickHandler('date')}
              className={`${styles["table-header-item"]} ${styles["table-header-date"]}`}
            >
              {i18n.t("date").toUpperCase()}
              {renderOrderIcon('date')}
            </div>
            <div
              className={`${styles["table-header-item"]} ${styles["table-header-time"]}`}
            >
              {i18n.t("time").toUpperCase()}
            </div>
            <div
              data-automation-id="sort-by-path_name"
              onClick={() => headerClickHandler && headerClickHandler('path_name')}
              className={`${styles["table-header-item"]} ${styles["table-header-location"]}`}
            >
              {i18n.t("location").toUpperCase()}
              {renderOrderIcon('path_name')}
            </div>
            <div
              data-automation-id="sort-by-user"
              onClick={() => headerClickHandler && headerClickHandler('user__username')}
              className={`${styles["table-header-item"]} ${styles["table-header-user"]}`}
            >
              {i18n.t("user").toUpperCase()}
              {renderOrderIcon('user__username')}
            </div>
            <div
              data-automation-id="sort-by-status"
              onClick={() => headerClickHandler && headerClickHandler('status')}
              className={`${styles["table-header-item"]} ${styles["table-header-status"]}`}
            >
              {i18n.t("status").toUpperCase()}
              {renderOrderIcon('status')}
            </div>
            <div className={`${styles["table-header-item"]} ${styles["table-header-modified"]}`}>
            </div>
            <div className={`${styles["table-header-item"]} ${styles["table-header-button"]}`}></div>
          </div>

          <div className={styles["table-content"]}>
            {audits && audits.map((audit) => (
              <div className={styles["table-content-item"]} key={audit.id}>
                <AuditTableItem
                  audit={audit}
                  isSelected={selected === audit.id}
                  handleSelect={handleSelectOne}
                  handleClick={() => handleClickAudit(audit)}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Mobile */}
      {isMobile && (
        <div className={styles["table-mobile"]} data-automation-id="audit-table">
          <div className={styles["table-header"]}>
            <div
              data-automation-id="sort-by-date"
              onClick={() => headerClickHandler && headerClickHandler('date')}
              className={`${styles["table-header-item"]} ${styles["table-header-date"]}`}
            >
              {i18n.t("date").toUpperCase()}
              {renderOrderIcon('date')}
            </div>
            <div
              data-automation-id="sort-by-path_name"
              onClick={() => headerClickHandler && headerClickHandler('path_name')}
              className={`${styles["table-header-item"]} ${styles["table-header-location"]}`}
            >
              {i18n.t("location").toUpperCase()}
              {renderOrderIcon('path_name')}
            </div>
            <div
              data-automation-id="sort-by-user"
              onClick={() => headerClickHandler && headerClickHandler('user__username')}
              className={`${styles["table-header-item"]} ${styles["table-header-user"]}`}
            >
              {i18n.t("user").toUpperCase()}
              {renderOrderIcon('user__username')}
            </div>
            <div
              data-automation-id="sort-by-status"
              onClick={() => headerClickHandler && headerClickHandler('status')}
              className={`${styles["table-header-item"]} ${styles["table-header-status"]}`}
            >
              {i18n.t("status").toUpperCase()}
              {renderOrderIcon('status')}
            </div>
          </div>

          <div className={styles["table-content"]}>
            {audits && audits.map((audit) => (
              <div className={styles["table-content-item"]} key={audit.id}>
                <AuditTableItemMobile
                  audit={audit}
                  isSelected={selected === audit.id}
                  handleSelect={handleSelectOne}
                  handleClick={() => handleClickAudit(audit)}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AuditTable;
